import { render } from "./PeriscopeTutorialScreen.vue?vue&type=template&id=7db1e0c4&scoped=true"
import script from "./PeriscopeTutorialScreen.vue?vue&type=script&lang=js"
export * from "./PeriscopeTutorialScreen.vue?vue&type=script&lang=js"

import "./PeriscopeTutorialScreen.vue?vue&type=style&index=0&id=7db1e0c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db1e0c4"]])

export default __exports__